import React from "react";
import { MessageBox } from "../components/Common/MessageBox";

export const NotFoundPage = () => {
  return (
    <MessageBox title="404 Page Not Found" message="We can't find the page you are looking for." />
  );
};
